import { useTranslation } from 'react-i18next';
import ConfirmationDialog from '../../../core-components/theme/components/DialogBox/ConfirmationDialog';
import { DeleteBatchConfigModalProps } from '../types/BatchConfigType';
import { useDeleteBatchConfig } from '../hooks/useDeleteBatchConfig';

export default function DeleteBatchConfigModal({
  handleClose,
  data,
}: DeleteBatchConfigModalProps) {
  const { t } = useTranslation();
  const { actions, handleCancel } = useDeleteBatchConfig(handleClose, data);

  return (
    <ConfirmationDialog
      open={true}
      actions={actions}
      handleClose={handleCancel}
      title={t('batchConfig.deleteTitle', 'Delete Batch Configuration')}
      description={t('batchConfig.deleteDescription', 'This will be removed from all places it’s used. Are you sure you want to delete it?')}
    />
  );
}
